import { IconArrowRight, IconBuildingBank, IconChartPie } from '@tabler/icons-react'

import { FormattedMessage } from '@subaio/components'

import { ButtonSolid } from 'components/Buttons'

import { Container } from './Container'
import { Marker } from './Marker'
import { Step } from './Step'
import { StepContent } from './StepContent'
import { Title } from './Title'

type Props = {
	isDemoData: boolean

	openCollectionFlow: () => Promise<void>
}

export const Timeline = ({ isDemoData, openCollectionFlow }: Props) => (
	<Container>
		<Step isActive>
			<Marker isActive>1</Marker>
			<StepContent>
				<Title>
					{isDemoData ? (
						<FormattedMessage id='home.demoData.title' defaultMessage='Connect to demo data' />
					) : (
						<FormattedMessage id='home.yourData.title' defaultMessage='Connect your bank' />
					)}
					{isDemoData ? (
						<IconChartPie aria-hidden='true' size={22} />
					) : (
						<IconBuildingBank aria-hidden='true' size={22} />
					)}
				</Title>
				<p>
					{isDemoData ? (
						<FormattedMessage
							id='home.demoData.description'
							defaultMessage='Choose a predefined persona to explore realistic financial data without connecting your bank.'
						/>
					) : (
						<FormattedMessage
							id='home.yourData.description'
							defaultMessage='Securely connect your bank to bring your financial data into Finance Data.'
						/>
					)}
				</p>
				<ButtonSolid
					label={
						<>
							{isDemoData ? (
								<FormattedMessage id='home.demoData.action' defaultMessage='Choose demo data' />
							) : (
								<FormattedMessage id='home.yourData.action' defaultMessage='Connect bank' />
							)}
							<IconArrowRight aria-hidden='true' size={24} strokeWidth={1.2} />
						</>
					}
					onClick={openCollectionFlow}
				/>
			</StepContent>
		</Step>
		<Step>
			<Marker>2</Marker>
			<StepContent>
				<Title>
					<FormattedMessage id='home.startBuilding' defaultMessage='Start building' />
				</Title>
			</StepContent>
		</Step>
	</Container>
)
